import React, { useState, useCallback, useEffect, useRef } from 'react'
import { Button, Col, Container, Form, FormControl, FormGroup, Image, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import { fetch } from '../../../utils';
import useRazorpay from "react-razorpay";
import CryptoJS from "crypto-js";
import OrderSummeryCheckup from './OrderSummeryCheckup';
import { useNavigate } from 'react-router-dom';
import { setOrderId, } from '../../../reducers/orderSlice';
import { clearCart } from '../../../reducers/cart';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import logoimg from '../../assets/images/logo.png'




const CheckOut = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const cart = useSelector(state => state.cart.items);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [addressData, setAddressData] = useState({});
    const [shipPinValid, setShipPinValid] = useState(false);
    const [billPinValid, setBillPinValid] = useState(false);
    const [shipToDifferentAddress, setShipToDifferentAddress] = useState(false);
    const [errors, setErrors] = useState({});
    const [tokenData, setTokenData] = useState(null);

    const getTokenData = () => {
        try {
            const raw = localStorage.getItem('muskan_token_data');
            if (!raw) return null;
            const data = JSON.parse(raw);
            return data && typeof data === 'object' ? data : null;
        } catch (e) {
            return null;
        }
    };

    useEffect(() => {
        const token = getTokenData();
        setTokenData(token);
    }, []);

    const isLoggedIn = !!tokenData?.customer_id;

    const getCustomerEmail = () => {
        return tokenData?.customer_email ||
            tokenData?.email ||
            tokenData?.customerEmail ||
            '';
    };

    const [formData, setFormData] = useState({
        customer_email: getCustomerEmail(),
        ship_fname: '',
        ship_lname: '',
        ship_company: '',
        ship_adderss_one: '',
        ship_adderss_two: '',
        ship_pincode: '',
        ship_city: '',
        ship_state: '',
        ship_country: '',
        ship_mobile: '',
        bill_fname: '',
        bill_lname: '',
        bill_company: '',
        bill_adderss_one: '',
        bill_adderss_two: '',
        bill_pincode: '',
        bill_city: '',
        bill_state: '',
        bill_country: '',
        bill_mobile: ''
    });

    useEffect(() => {
        const email = getCustomerEmail();
        setFormData(prev => ({
            ...prev,
            customer_email: email || prev.customer_email || ''
        }));
    }, [tokenData]);

    useEffect(() => {
        if (tokenData?.customer_id) getAddressData(tokenData.customer_id);
    }, [tokenData?.customer_id]);

    const getAddressData = async customerId => {
        try {
            const response = await fetch('/customer/address', 'POST', { customer_id: customerId }, null);
            const data = response?.data?.data || {};
            setAddressData(data);
        } catch (error) {
            console.error('ADDRESS ERROR:', error);
        }
    };

    useEffect(() => {
        if (!addressData) return;

        const shipping = addressData?.ship_adderss || {};
        const billing = addressData?.bill_adderss || {};

        setFormData(prev => ({
            ...prev,
            customer_email: getCustomerEmail() || addressData?.customer_email || prev.customer_email || '',
            bill_fname: billing.bill_fname || '',
            bill_lname: billing.bill_lname || '',
            bill_company: billing.bill_company || '',
            bill_adderss_one: billing.bill_adderss_one || '',
            bill_adderss_two: billing.bill_adderss_two || '',
            bill_pincode: billing.bill_pincode || '',
            bill_city: billing.bill_city || '',
            bill_state: billing.bill_state || '',
            bill_country: billing.bill_country || '',
            bill_mobile: billing.bill_mobile || '',
            ship_fname: shipping.ship_fname || '',
            ship_lname: shipping.ship_lname || '',
            ship_company: shipping.ship_company || '',
            ship_adderss_one: shipping.ship_adderss_one || '',
            ship_adderss_two: shipping.ship_adderss_two || '',
            ship_pincode: shipping.ship_pincode || '',
            ship_city: shipping.ship_city || '',
            ship_state: shipping.ship_state || '',
            ship_country: shipping.ship_country || '',
            ship_mobile: shipping.ship_mobile || ''
        }));

        if (shipping.ship_pincode) {
            setShipPinValid(true);
        }
    }, [addressData]);

    const handleInputChange = e => {
        const { name, value, placeholder } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({
            ...prev,
            [name]: value.trim() ? '' : `${placeholder || name} is required`
        }));

        if (name === 'ship_pincode') {
            setShipPinValid(false);
        }
        if (name === 'bill_pincode') {
            setBillPinValid(false);
        }
    };

    const fetchPinCodeDetails = async (pinCode, isBilling = false) => {
        const pin = String(pinCode || '').trim();

        if (pin.length !== 6) {
            if (isBilling) setBillPinValid(false);
            else setShipPinValid(false);
            return;
        }

        try {
            const response = await fetch('/pincode/by-pincode', 'POST', { pincode: pin }, null);
            const details = response?.data?.data?.pincode_details;

            if (!details) {
                if (isBilling) setBillPinValid(false);
                else setShipPinValid(false);

                setErrors(prev => ({
                    ...prev,
                    [isBilling ? 'bill_pincode' : 'ship_pincode']: 'Enter valid Pin code'
                }));

                toast.error('Enter valid PIN Code.', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000
                });
                return;
            }

            if (isBilling) setBillPinValid(true);
            else setShipPinValid(true);

            setFormData(prev => ({
                ...prev,
                [isBilling ? 'bill_city' : 'ship_city']: details.city || '',
                [isBilling ? 'bill_state' : 'ship_state']: details.state || '',
                [isBilling ? 'bill_country' : 'ship_country']: details.country || ''
            }));

            setErrors(prev => ({
                ...prev,
                [isBilling ? 'bill_pincode' : 'ship_pincode']: '',
                [isBilling ? 'bill_city' : 'ship_city']: '',
                [isBilling ? 'bill_state' : 'ship_state']: '',
                [isBilling ? 'bill_country' : 'ship_country']: ''
            }));
        } catch (error) {

            if (isBilling) setBillPinValid(false);
            else setShipPinValid(false);

            setErrors(prev => ({
                ...prev,
                [isBilling ? 'bill_pincode' : 'ship_pincode']: 'Enter valid Pin code'
            }));
        }
    };

    const getErrorMessage = error => {
        return error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.response?.data?.detail ||
            error?.message ||
            'Something went wrong. Please try again.';
    };

    const getPaymentUrl = data => {
        if (!data) return '';

        const candidates = [
            data?.payment_url,
            data?.paymentUrl,
            data?.payment_link,
            data?.paymentLink,
            data?.redirect_url,
            data?.redirectUrl,
            data?.url,
            data?.payment_links?.web,
            data?.payment_links?.web_url,
            data?.payment_links?.redirect,
            data?.order?.payment_url,
            data?.order?.paymentUrl,
            data?.order?.payment_link,
            data?.order?.paymentLink,
            data?.order?.redirect_url,
            data?.order?.redirectUrl,
            data?.order?.url,
            data?.order?.payment_links?.web,
            data?.order?.payment_links?.web_url,
            data?.session?.payment_links?.web,
            data?.session?.payment_url,
            data?.session?.redirect_url,
            data?.response?.payment_links?.web,
            data?.response?.payment_url
        ];

        const url = candidates.find(
            item => typeof item === 'string' && item.trim() !== ''
        );

        return url || '';
    };

    const handleLogout = () => {
        localStorage.removeItem('muskan_token');
        localStorage.removeItem('muskan_token_data');
        setTokenData(null);
        navigate('/account/login');
    };

    const validateForm = () => {
        const newErrors = {};
        let valid = true;

        const required = (field, message, regex) => {
            const value = String(formData[field] || '').trim();

            if (!value) {
                newErrors[field] = message;
                valid = false;
                return;
            }

            if (regex && !regex.test(value)) {
                newErrors[field] = message;
                valid = false;
            }
        };

        required('customer_email', 'Email is required', /^[^\s@]+@[^\s@]+\.[^\s@]+$/);
        required('ship_pincode', 'Pin Code is required');
        required('ship_fname', 'First Name is required');
        required('ship_lname', 'Last Name is required');
        required('ship_mobile', 'Enter 10 digit mobile number', /^[0-9]{10}$/);
        required('ship_adderss_one', 'Address is required');
        required('ship_city', 'City is required');
        required('ship_state', 'State is required');
        required('ship_country', 'Country is required');

        const savedShipPin = String(addressData?.ship_adderss?.ship_pincode || '');
        const currentShipPin = String(formData.ship_pincode || '');

        if (currentShipPin) {
            if (!shipPinValid && savedShipPin !== currentShipPin) {
                newErrors.ship_pincode = 'Enter valid Pin code';
                valid = false;
            }
        }

        if (shipToDifferentAddress) {
            required('bill_pincode', 'Pin Code is required');
            required('bill_fname', 'First Name is required');
            required('bill_lname', 'Last Name is required');
            required('bill_mobile', 'Enter 10 digit mobile number', /^[0-9]{10}$/);
            required('bill_adderss_one', 'Address is required');
            required('bill_city', 'City is required');
            required('bill_state', 'State is required');
            required('bill_country', 'Country is required');

            const savedBillPin = String(addressData?.bill_adderss?.bill_pincode || '');
            const currentBillPin = String(formData.bill_pincode || '');

            if (currentBillPin && !billPinValid && savedBillPin !== currentBillPin) {
                newErrors.bill_pincode = 'Enter valid Pin code';
                valid = false;
            }
        }

        setErrors(newErrors);
        return valid;
    };


    const handlePlaceOrder = async () => {
        if (isLoading) return;

        if (!cart?.length) {
            setErrorMessage("Your cart is empty.");
            return;
        }

        if (!validateForm()) return;

        setErrorMessage("");
        setIsLoading(true);

        try {
            const tokenData = getTokenData();

            const customerId = tokenData?.customer_id || "";

            const customerEmail =
                formData.customer_email ||
                tokenData?.customer_email ||
                tokenData?.email ||
                tokenData?.customerEmail ||
                addressData?.customer_email ||
                "";

            if (!customerEmail) {
                setErrors(prev => ({
                    ...prev,
                    customer_email: "Email is required"
                }));
                setIsLoading(false);
                return;
            }

            const body = {
                customer_id: customerId,
                customer_email: customerEmail,
                cart: JSON.stringify(cart),

                ship_fname: formData.ship_fname,
                ship_lname: formData.ship_lname,
                ship_company: formData.ship_company || "",
                ship_adderss_one: formData.ship_adderss_one,
                ship_adderss_two: formData.ship_adderss_two || "",
                ship_pincode: formData.ship_pincode,
                ship_city: formData.ship_city,
                ship_state: formData.ship_state,
                ship_country: formData.ship_country,
                ship_mobile: formData.ship_mobile,

                bill_fname: shipToDifferentAddress
                    ? formData.bill_fname
                    : formData.ship_fname,

                bill_lname: shipToDifferentAddress
                    ? formData.bill_lname
                    : formData.ship_lname,

                bill_company: shipToDifferentAddress
                    ? formData.bill_company || ""
                    : formData.ship_company || "",

                bill_adderss_one: shipToDifferentAddress
                    ? formData.bill_adderss_one
                    : formData.ship_adderss_one,

                bill_adderss_two: shipToDifferentAddress
                    ? formData.bill_adderss_two || ""
                    : formData.ship_adderss_two || "",

                bill_pincode: shipToDifferentAddress
                    ? formData.bill_pincode
                    : formData.ship_pincode,

                bill_city: shipToDifferentAddress
                    ? formData.bill_city
                    : formData.ship_city,

                bill_state: shipToDifferentAddress
                    ? formData.bill_state
                    : formData.ship_state,

                bill_country: shipToDifferentAddress
                    ? formData.bill_country
                    : formData.ship_country,

                bill_mobile: shipToDifferentAddress
                    ? formData.bill_mobile
                    : formData.ship_mobile
            };


            const response = await fetch(
                "/order/save",
                "POST",
                body,
                null
            );

            const data =
                response?.data?.data ||
                response?.data ||
                null;


            if (!data)
                throw new Error("Invalid order response.");

            if (data.token)
                localStorage.setItem(
                    "muskan_token",
                    data.token
                );

            const orderId =
                data?.order?.cust_order_id ||
                data?.cust_order_id ||
                null;

            if (orderId)
                dispatch(setOrderId(orderId));

            const paymentUrl =
                data?.paymentUrl ||
                data?.payment_url ||
                data?.order?.paymentUrl ||
                null;


            if (!paymentUrl)
                throw new Error(
                    "HDFC Payment URL not received."
                );
            sessionStorage.removeItem("cart");

            window.location.assign(paymentUrl);


        } catch (error) {

            setErrorMessage(
                getErrorMessage(error)
            );

            setIsLoading(false);
        }
    };



    const handleShipPinCodeKeyDown = e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            fetchPinCodeDetails(formData.ship_pincode, false);
        }
    };

    const handleBillPinCodeKeyDown = e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            fetchPinCodeDetails(formData.bill_pincode, true);
        }
    };

    if (!cart.length) {
        return (
            <Container>
                <Row className="pt-2">
                    <Col>
                        <font>Home › Shipping › Payment</font>
                        <div className="pt-4"><h3>Checkout</h3></div>
                        <div className="text-center my-5">
                            <Image src={require('../../assets/images/empty-cart.jpg')} alt="image" />
                            <h3>Oops! Your Cart is empty!</h3>
                            <p>Looks like you haven't added<br />anything to your cart yet</p>
                            <Link to="/" className="btn btn-primary">Shop Now</Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <>
            <Container>
                <Row>
                    <Col sm={8} className="r-border">
                        <div className="py-5">
                            <font>Home › Shipping › Payment</font>
                        </div>

                        {isLoggedIn ? (
                            <>
                                <h6>Contact</h6>
                                <Row className="pt-4">
                                    <Col sm={1} lg={1} xs={1}>
                                        <Image
                                            src={require('../../assets/images/user.jpg')}
                                            alt=""
                                            className="w-100"
                                        />
                                    </Col>
                                    <Col sm={11} lg={11} xs={11} className="px-0">
                                        <p className="m-0">
                                            {tokenData?.customer_fname || ''}{' '}
                                            {tokenData?.customer_lname || ''}
                                            {' '}({getCustomerEmail() || 'Email not available'})
                                        </p>
                                        <p
                                            className="main-color"
                                            onClick={handleLogout}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Log Out
                                        </p>
                                    </Col>
                                </Row>
                            </>
                        ) : (
                            <>
                                <h6 className="pull-left f-w-8">CONTACT</h6>
                                <p className="text-end">
                                    Have an account?{' '}
                                    <Link
                                        className="main-bg text-white px-2 rounded-1"
                                        to="/account/login"
                                    >
                                        Log in
                                    </Link>
                                </p>
                                <FormGroup as={Col} md="12">
                                    <Form.Label>
                                        Enter Email <span className="text-danger">*</span>
                                    </Form.Label>
                                    <FormControl
                                        type="email"
                                        name="customer_email"
                                        value={formData.customer_email}
                                        onChange={handleInputChange}
                                        placeholder="Enter email"
                                    />
                                    {errors.customer_email && (
                                        <span className="text-danger">{errors.customer_email}</span>
                                    )}
                                </FormGroup>
                            </>
                        )}

                        <div className="pt-4 checkout-style">
                            <h6 className="text-dark mb-3">Shipping address</h6>

                            <Row>
                                <FormGroup as={Col} md="4" className="col-mt">
                                    <FormControl
                                        type="text"
                                        inputMode="numeric"
                                        name="ship_pincode"
                                        value={formData.ship_pincode}
                                        onChange={handleInputChange}
                                        onKeyDown={handleShipPinCodeKeyDown}
                                        onBlur={() => fetchPinCodeDetails(formData.ship_pincode, false)}
                                        placeholder="PIN Code"
                                    />
                                    {errors.ship_pincode && (
                                        <span className="text-danger">{errors.ship_pincode}</span>
                                    )}
                                </FormGroup>

                                <FormGroup as={Col} md="4" className="col-mt">
                                    <FormControl
                                        type="text"
                                        name="ship_city"
                                        value={formData.ship_city}
                                        onChange={handleInputChange}
                                        placeholder="City"
                                        readOnly
                                    />
                                    {errors.ship_city && (
                                        <span className="text-danger">{errors.ship_city}</span>
                                    )}
                                </FormGroup>

                                <FormGroup as={Col} md="4" className="col-mt">
                                    <FormControl
                                        type="text"
                                        name="ship_state"
                                        value={formData.ship_state}
                                        onChange={handleInputChange}
                                        placeholder="State"
                                        readOnly
                                    />
                                    {errors.ship_state && (
                                        <span className="text-danger">{errors.ship_state}</span>
                                    )}
                                </FormGroup>

                                <FormGroup as={Col} md="6" className="col-mt">
                                    <FormControl
                                        type="text"
                                        name="ship_fname"
                                        value={formData.ship_fname}
                                        onChange={handleInputChange}
                                        placeholder="First Name"
                                    />
                                    {errors.ship_fname && (
                                        <span className="text-danger">{errors.ship_fname}</span>
                                    )}
                                </FormGroup>

                                <FormGroup as={Col} md="6" className="col-mt">
                                    <FormControl
                                        type="text"
                                        name="ship_lname"
                                        value={formData.ship_lname}
                                        onChange={handleInputChange}
                                        placeholder="Last Name"
                                    />
                                    {errors.ship_lname && (
                                        <span className="text-danger">{errors.ship_lname}</span>
                                    )}
                                </FormGroup>

                                <FormGroup as={Col} md="4" className="col-mt">
                                    <FormControl
                                        type="text"
                                        inputMode="numeric"
                                        name="ship_mobile"
                                        value={formData.ship_mobile}
                                        onChange={handleInputChange}
                                        placeholder="Phone"
                                    />
                                    {errors.ship_mobile && (
                                        <span className="text-danger">{errors.ship_mobile}</span>
                                    )}
                                </FormGroup>

                                <FormGroup as={Col} md="4" className="col-mt">
                                    <FormControl
                                        type="text"
                                        name="ship_company"
                                        value={formData.ship_company}
                                        onChange={handleInputChange}
                                        placeholder="Company Name (optional)"
                                    />
                                </FormGroup>

                                <FormGroup as={Col} md="4" className="col-mt">
                                    <FormControl
                                        type="text"
                                        name="ship_country"
                                        value={formData.ship_country}
                                        onChange={handleInputChange}
                                        placeholder="Country"
                                        readOnly
                                    />
                                    {errors.ship_country && (
                                        <span className="text-danger">{errors.ship_country}</span>
                                    )}
                                </FormGroup>

                                <FormGroup as={Col} md="12" className="col-mt">
                                    <FormControl
                                        type="text"
                                        name="ship_adderss_one"
                                        value={formData.ship_adderss_one}
                                        onChange={handleInputChange}
                                        placeholder="Address"
                                    />
                                    {errors.ship_adderss_one && (
                                        <span className="text-danger">{errors.ship_adderss_one}</span>
                                    )}
                                </FormGroup>

                                <FormGroup as={Col} md="12" className="col-mt">
                                    <FormControl
                                        type="text"
                                        name="ship_adderss_two"
                                        value={formData.ship_adderss_two}
                                        onChange={handleInputChange}
                                        placeholder="Apartment, suite, unit, etc. (optional)"
                                    />
                                </FormGroup>

                                <div className="pt-4">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={shipToDifferentAddress}
                                            onChange={e => setShipToDifferentAddress(e.target.checked)}
                                        />
                                        &nbsp; Ship to a different address?
                                    </label>
                                </div>
                            </Row>

                            {shipToDifferentAddress && (
                                <>
                                    <h6 className="mt-3">Billing Details</h6>
                                    <Row className="mt-3">

                                        <FormGroup as={Col} md="4" className="col-mt">
                                            <FormControl
                                                type="text"
                                                inputMode="numeric"
                                                name="bill_pincode"
                                                value={formData.bill_pincode}
                                                onChange={handleInputChange}
                                                onKeyDown={handleBillPinCodeKeyDown}
                                                onBlur={() => fetchPinCodeDetails(formData.bill_pincode, true)}
                                                placeholder="PIN Code"
                                            />
                                            {errors.bill_pincode && (
                                                <span className="text-danger">{errors.bill_pincode}</span>
                                            )}
                                        </FormGroup>

                                        <FormGroup as={Col} md="4" className="col-mt">
                                            <FormControl
                                                type="text"
                                                name="bill_city"
                                                value={formData.bill_city}
                                                onChange={handleInputChange}
                                                placeholder="City"
                                                readOnly
                                            />
                                            {errors.bill_city && (
                                                <span className="text-danger">{errors.bill_city}</span>
                                            )}
                                        </FormGroup>

                                        <FormGroup as={Col} md="4" className="col-mt">
                                            <FormControl
                                                type="text"
                                                name="bill_state"
                                                value={formData.bill_state}
                                                onChange={handleInputChange}
                                                placeholder="State"
                                                readOnly
                                            />
                                            {errors.bill_state && (
                                                <span className="text-danger">{errors.bill_state}</span>
                                            )}
                                        </FormGroup>

                                        <FormGroup as={Col} md="6" className="col-mt">
                                            <FormControl
                                                type="text"
                                                name="bill_fname"
                                                value={formData.bill_fname}
                                                onChange={handleInputChange}
                                                placeholder="First Name"
                                            />
                                            {errors.bill_fname && (
                                                <span className="text-danger">{errors.bill_fname}</span>
                                            )}
                                        </FormGroup>

                                        <FormGroup as={Col} md="6" className="col-mt">
                                            <FormControl
                                                type="text"
                                                name="bill_lname"
                                                value={formData.bill_lname}
                                                onChange={handleInputChange}
                                                placeholder="Last Name"
                                            />
                                            {errors.bill_lname && (
                                                <span className="text-danger">{errors.bill_lname}</span>
                                            )}
                                        </FormGroup>

                                        <FormGroup as={Col} md="4" className="col-mt">
                                            <FormControl
                                                type="text"
                                                inputMode="numeric"
                                                name="bill_mobile"
                                                value={formData.bill_mobile}
                                                onChange={handleInputChange}
                                                placeholder="Phone"
                                            />
                                            {errors.bill_mobile && (
                                                <span className="text-danger">{errors.bill_mobile}</span>
                                            )}
                                        </FormGroup>

                                        <FormGroup as={Col} md="4" className="col-mt">
                                            <FormControl
                                                type="text"
                                                name="bill_company"
                                                value={formData.bill_company}
                                                onChange={handleInputChange}
                                                placeholder="Company Name"
                                            />
                                        </FormGroup>

                                        <FormGroup as={Col} md="4" className="col-mt">
                                            <FormControl
                                                type="text"
                                                name="bill_country"
                                                value={formData.bill_country}
                                                onChange={handleInputChange}
                                                placeholder="Country"
                                            />
                                            {errors.bill_country && (
                                                <span className="text-danger">{errors.bill_country}</span>
                                            )}
                                        </FormGroup>

                                        <FormGroup as={Col} md="12">
                                            <FormControl
                                                type="text"
                                                name="bill_adderss_one"
                                                value={formData.bill_adderss_one}
                                                onChange={handleInputChange}
                                                placeholder="House number and street name"
                                            />
                                            {errors.bill_adderss_one && (
                                                <span className="text-danger">{errors.bill_adderss_one}</span>
                                            )}
                                            <br />
                                            <FormControl
                                                type="text"
                                                name="bill_adderss_two"
                                                value={formData.bill_adderss_two}
                                                onChange={handleInputChange}
                                                placeholder="Apartment, suite, unit, etc. (optional)"
                                            />
                                        </FormGroup>
                                    </Row>
                                </>
                            )}

                            <Row>
                                <Col sm={6} className="p-3">
                                    {errorMessage && (
                                        <font color="red" size="2">
                                            <b>{errorMessage}</b>
                                        </font>
                                    )}
                                </Col>

                                <Col sm={6} className="text-end">
                                    <Button
                                        type="button"
                                        className="btn btn-danger mt-3 py-3"
                                        onClick={handlePlaceOrder}
                                        disabled={isLoading || !cart.length}
                                    >
                                        {isLoading ? 'Please wait...' : 'Continue to Payment'}
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Col>

                    <Col sm={4}>
                        <OrderSummeryCheckup />
                    </Col>
                </Row>
            </Container>

            <ToastContainer />
        </>
    );
};

export default CheckOut;